/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.User = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The User model module.
   * @module model/User
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>User</code>.
   * @alias module:model/User
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>User</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/User} obj Optional instance to populate.
   * @return {module:model/User} The populated <code>User</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FirstName')) {
        obj['FirstName'] = ApiClient.convertToType(data['FirstName'], 'String');
      }
      if (data.hasOwnProperty('LastName')) {
        obj['LastName'] = ApiClient.convertToType(data['LastName'], 'String');
      }
      if (data.hasOwnProperty('Email')) {
        obj['Email'] = ApiClient.convertToType(data['Email'], 'String');
      }
      if (data.hasOwnProperty('PasswordHash')) {
        obj['PasswordHash'] = ApiClient.convertToType(data['PasswordHash'], 'String');
      }
      if (data.hasOwnProperty('MobilePhoneNumber')) {
        obj['MobilePhoneNumber'] = ApiClient.convertToType(data['MobilePhoneNumber'], 'String');
      }
      if (data.hasOwnProperty('SystemLanguageID')) {
        obj['SystemLanguageID'] = ApiClient.convertToType(data['SystemLanguageID'], 'Integer');
      }
      if (data.hasOwnProperty('TimeZoneIdentifier')) {
        obj['TimeZoneIdentifier'] = ApiClient.convertToType(data['TimeZoneIdentifier'], 'String');
      }
      if (data.hasOwnProperty('ProfileImageURI')) {
        obj['ProfileImageURI'] = ApiClient.convertToType(data['ProfileImageURI'], 'String');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('AdministrationUserTypeID')) {
        obj['AdministrationUserTypeID'] = ApiClient.convertToType(data['AdministrationUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultLoginCompanyID')) {
        obj['DefaultLoginCompanyID'] = ApiClient.convertToType(data['DefaultLoginCompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('EULASignedDate')) {
        obj['EULASignedDate'] = ApiClient.convertToType(data['EULASignedDate'], 'Date');
      }
      if (data.hasOwnProperty('LastLoginDate')) {
        obj['LastLoginDate'] = ApiClient.convertToType(data['LastLoginDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} FirstName
   * @default ''
   */
  exports.prototype['FirstName'] = '';
  /**
   * @member {String} LastName
   * @default ''
   */
  exports.prototype['LastName'] = '';
  /**
   * @member {String} Email
   * @default ''
   */
  exports.prototype['Email'] = '';
  /**
   * @member {String} PasswordHash
   * @default ''
   */
  exports.prototype['PasswordHash'] = '';
  /**
   * @member {String} MobilePhoneNumber
   * @default ''
   */
  exports.prototype['MobilePhoneNumber'] = '';
  /**
   * @member {Integer} SystemLanguageID
   * @default 0
   */
  exports.prototype['SystemLanguageID'] = 0;
  /**
   * @member {String} TimeZoneIdentifier
   * @default ''
   */
  exports.prototype['TimeZoneIdentifier'] = '';
  /**
   * @member {String} ProfileImageURI
   * @default ''
   */
  exports.prototype['ProfileImageURI'] = '';
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Integer} AdministrationUserTypeID
   * @default 0
   */
  exports.prototype['AdministrationUserTypeID'] = 0;
  /**
   * @member {Integer} DefaultLoginCompanyID
   * @default 0
   */
  exports.prototype['DefaultLoginCompanyID'] = 0;
  /**
   * @member {Date} EULASignedDate
   */
  exports.prototype['EULASignedDate'] = undefined;
  /**
   * @member {Date} LastLoginDate
   */
  exports.prototype['LastLoginDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


